import { render, staticRenderFns } from "./LiquidationArchives.vue?vue&type=template&id=38ec6fcc"
import script from "./LiquidationArchives.vue?vue&type=script&lang=js"
export * from "./LiquidationArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports